import { z } from 'zod';
import { bilingualTextInputSchema, bilingualTextSchema } from '../common/refs.js';
/**
 * إعدادات الأمانات (cash-deposits.md section 10): organisation name and
 * receipt header, the deposit declaration and delivery acknowledgement texts,
 * and the receipt footer. Every value is bilingual `{ ar, en }`; the receipt
 * and the tablet use the language chosen by the customer.
 */
export const SETTING_KEYS = [
    'organisationName',
    'receiptHeader',
    'depositDeclaration',
    'deliveryAcknowledgement',
    'receiptFooter',
];
export const settingKeySchema = z.enum(SETTING_KEYS);
/** The stored key of the phone verification switch (a boolean, not a bilingual text). */
export const PHONE_VERIFICATION_SETTING_KEY = 'phoneVerificationEnabled';
export const depositSettingsSchema = z.object({
    organisationName: bilingualTextSchema,
    receiptHeader: bilingualTextSchema,
    depositDeclaration: bilingualTextSchema,
    deliveryAcknowledgement: bilingualTextSchema,
    receiptFooter: bilingualTextSchema,
    /**
     * تأكيد رقم الهاتف برمز واتساب (customers.md section 10.1): off by default.
     * When on, the depositor at تأكيد الإيداع, the actual recipient at delivery
     * and a registered party's phone changed by an edit are verified with a
     * WhatsApp code before the save.
     */
    phoneVerificationEnabled: z.boolean(),
    updatedAt: z.iso.datetime({ offset: true }).nullable(),
});
/** PATCH /settings: any subset of keys; each value needs both languages. */
export const updateDepositSettingsSchema = z
    .object({
    organisationName: bilingualTextInputSchema(150),
    receiptHeader: bilingualTextInputSchema(300),
    depositDeclaration: bilingualTextInputSchema(2000),
    deliveryAcknowledgement: bilingualTextInputSchema(2000),
    receiptFooter: bilingualTextInputSchema(500),
    phoneVerificationEnabled: z.boolean(),
})
    .partial()
    .refine((value) => Object.keys(value).length > 0, 'at least one setting is required');
/** GET /phone-verifications/setting: the switch, readable by every employee who saves a phone. */
export const phoneVerificationSettingSchema = z.object({ enabled: z.boolean() });
//# sourceMappingURL=contract.js.map